var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"geofences-edit-page h-100"},[_c('div',{staticClass:"h-100 w-100",attrs:{"id":"geofence-map"}})])
}]

export { render, staticRenderFns }